import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NSSkeletonModule } from '@norfolk-southern/accessns-components';

import { UTEmptyPermitComponent } from '@ruby/shared/components/ut-empty-permit/ut-empty-permit.component';
import { PermitCommentsModule } from '@ruby/shared/dialogs/unit-train/permit-comments/permit-comments.module';
import { TrainConsistModule } from '@ruby/shared/dialogs/unit-train/train-consist/train-consist.module';
import { TrainRouteModule } from '@ruby/shared/dialogs/unit-train/train-route/train-route.module';
import { PipesModule } from '@ruby/shared/pipes/pipes.module';

@NgModule({
  declarations: [UTEmptyPermitComponent],
  imports: [
    CommonModule,
    MatDividerModule,
    MatIconModule,
    MatButtonModule,
    PermitCommentsModule,
    MatTooltipModule,
    TrainRouteModule,
    TrainConsistModule,
    NSSkeletonModule,
    PipesModule
  ],
  exports: [UTEmptyPermitComponent]
})
export class UTEmptyPermitModule {}
